module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"delete-packaging":"Delete Packaging","packaging-deleted":"Packaging deleted","failed-delete-packaging":"Failed to delete packaging","tube-filter":"Tube Filter"}}')
  delete Component.options._Ctor
}
